import { __ } from '@wordpress/i18n';
import { decodeEntities } from '@wordpress/html-entities';

const CourseListItemCategory = ({ categories }) => {
	return (
		<div className="upcoming-event-list__item__category">
			{categories.map((category) => (
				<span key={category.id}>{decodeEntities(category.name)}</span>
			))}
		</div>
	);
};

export default CourseListItemCategory;
